import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast.css';

function renderContent(message, type) {
  let glyph = 'i';
  if (type === 'success') glyph = '✓';
  if (type === 'warn') glyph = '!';
  if (type === 'error') glyph = '!';

  return (
    <div className="ll-toast-body">
      <span className="ll-toast-icon" aria-hidden="true">{glyph}</span>
      <p className="ll-toast-message">{message}</p>
    </div>
  );
}

export default function notify(message, type) {
  switch (type) {
    case 'info':
      toast.info(renderContent(message, 'info'), {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        className: 'll-toast ll-toast--info',
      });
      break;
    case 'error':
      toast.error(renderContent(message, 'error'), {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        className: 'll-toast ll-toast--error',
      });
      break;
    case 'success':
      toast.success(renderContent(message, 'success'), {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        className: 'll-toast ll-toast--success',
      });
      break;
    case 'warn':
      toast.warn(renderContent(message, 'warn'), {
        position: 'bottom-right',
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        className: 'll-toast ll-toast--warn',
      });
      break;
    default:
      toast(renderContent(message, 'info'), {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: false,
        className: 'll-toast',
      });
      break;
  }
}